import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import type {
  GetLoginLogsPayload,
  GetLoginLogsResponse,
  GetUserLogsPayload,
  GetUserLogsResponse,
} from "./types";

export const useGetUserLogs = (payload: GetUserLogsPayload) => {
  return useQuery<GetUserLogsResponse>({
    queryKey: [queryKeys.getUserLogs, payload],
    queryFn: async () => api.post("/audit-logs/users-logs", payload).then((res) => res.data),
  });
};

export const useGetLoginLogs = (payload: GetLoginLogsPayload) => {
  return useQuery<GetLoginLogsResponse>({
    queryKey: [queryKeys.getLoginLogs, payload],
    queryFn: async () => api.post("/audit-logs/login-logs", payload).then((res) => res.data),
  });
};
